import { createRequest, getProxyHeadersPlugin } from '@direct-frontend/modules-request';
import { authorizePlugin } from './plugins/authorizePlugin';
import { apiRequestCommon } from './apiRequestCommon';
import { getCSRFPlugin } from './plugins';

export const apiV1Request = createRequest({
    ...apiRequestCommon,

    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
    },
    jsonContentTypeHeaders: ['application/json'],
    plugins: [
        getProxyHeadersPlugin([
            'x-original-host',
            'cookie',
            'user-agent',
            'accept-language',
            'x-forwarded-for',
            'x-forwarded-for-y',
            'x-real-ip',
            'x-trace-id',
            'traceparent',
            'testname',
            'testRunId',
        ]),
        getCSRFPlugin(),
        authorizePlugin(),
    ],
});
